import SoftLoading from './SoftLoading';

export default SoftLoading;
